/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaintenanceInfoDto } from '../../models/maintenance-info-dto';

export interface GetMaintenanceInfo$Params {
}

export function getMaintenanceInfo(http: HttpClient, rootUrl: string, params?: GetMaintenanceInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<MaintenanceInfoDto>> {
  const rb = new RequestBuilder(rootUrl, getMaintenanceInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MaintenanceInfoDto>;
    })
  );
}

getMaintenanceInfo.PATH = '/api/v1/maintenance';
